module.exports = __webpack_public_path__ + "static/media/img18.9e1e61c3.jpg";